import React from "react";
import { Avatar } from "@mui/material";
import { useProfileImageSas, buildProfileImageUrl } from "../../hooks/useProfileImageSas";

export interface ContactProfile {
	contactId: string | undefined;
	name?: string;
}

interface ContactProfileImageProps {
	profile: ContactProfile;
	cssClass?: string;
}

/**
 * Admin-side stand-in for the portal's ContactProfileImage. Renders an MUI
 * Avatar backed by this app's profile-image SAS helper (reused rather than
 * porting the portal's useAzureStorage stack), falling back to the name initial.
 */
const ContactProfileImage: React.FC<ContactProfileImageProps> = ({ profile, cssClass }) => {
	const { data: sasData } = useProfileImageSas();
	const url = profile.contactId ? buildProfileImageUrl(profile.contactId, sasData) : "";

	if (!profile.contactId) return null;

	return (
		<Avatar
			src={url || undefined}
			className={cssClass}
			sx={{ bgcolor: "#002f67" }}
		>
			{(profile.name ?? "").charAt(0)}
		</Avatar>
	);
};

export default React.memo(ContactProfileImage);
